import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { TranslationContext } from "../../umbilical_tools";
import { inputGroupStyles } from "./widgets";
import { HotelDestAutoCompleteInputField } from "../forms/inputGroup/helpers";
import jssVariables from "../../jss_setup";

const destStyles = createUseStyles({
  DestinationsPicker: (props) => ({
    ...inputGroupStyles(),
    "& input": { ...(props?.customStyles?.input ?? {}) },
    "& .rs-picker-input": {
      height: "3rem",
      width: "100%",
    },
    ...(props?.customStyles?.DestinationsPicker ?? {}),
  }),
  label: (props) => ({
    color: jssVariables.colors.text.dark,
    fontSize: "medium",
    ...(props?.customStyles?.label ?? {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    DestinationsPicker: (props) => ({
      gridGap: 0,
      ...(props?.customStyles?.DestinationsPicker?.smallscreen ?? {}),
    }),
    label: (props) => ({
      ...(props?.customStyles?.label?.smallscreen ?? {}),
    }),
  },
});
export function DestinationsPicker({
  id,
  name,
  label,
  types,
  customStyles,
  placeholder,
  value,
  isInFilters,
  isInRestaurants,
}) {
  const { t } = useContext(TranslationContext);

  const classes = destStyles({ customStyles });

  return (
    <div className={classes.DestinationsPicker} id={id}>
      <span className={classes.label}>
        {label ? label : `${t("destination")}`}
        {types.includes("ACC") && ` / ${t("hotel")}`}
      </span>
      <HotelDestAutoCompleteInputField
        name={name}
        types={types}
        placeholder={placeholder}
        value={value}
        customStyles={customStyles}
        isInFilters={isInFilters}
        isInRestaurants={isInRestaurants}
      />
    </div>
  );
}
DestinationsPicker.defaultProps = {
  name: "destinationObj",
  id: "",
  label: "",
  placeholder: "",
  customStyles: {},
  autocomplete: false,
  destinations: [],
  value: [],
  isInFilters: false,
  isInRestaurants: false,
};
DestinationsPicker.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  types: PropTypes.array,
  placeholder: PropTypes.string,
  customStyles: PropTypes.object,
  autocomplete: PropTypes.bool,
  destinations: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  isInFilters: PropTypes.bool,
  isInRestaurants: PropTypes.bool,
};
